import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChange,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FileUpload } from 'primeng/fileupload';
import { BaseFormComponent } from '../../../shared/class/base-form.class';
import { MONTHS_LIST } from '../../../shared/constansts/app.const';
import { FileUploadReq } from '../../models/file-upload-req';
import { RequestStatus } from '../../../shared/enums/request-status.enum';
@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent extends BaseFormComponent {
  @ViewChild('fileUpload') fileUpload: FileUpload | undefined;
  @Output() selectedFiles = new EventEmitter<any>();
  @Output() reset = new EventEmitter<boolean>();
  @Input() requestInProgress = false;
  @Input() override requestStatus = RequestStatus.None;
  @Output() resetStatus: EventEmitter<boolean> = new EventEmitter<boolean>();
  fileUploadForm: FormGroup;
  fileMonth: Date[] | undefined;
  months = MONTHS_LIST;
  protected files: File[] = [];

  allowedMimeTypes: string[] = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX
    'application/vnd.ms-excel', // XLS
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12', // XLSB
  ];

  constructor(protected override fb: FormBuilder) {
    super();
    this.fileUploadForm = this.fb.group({
      name: ['', [Validators.required]],
      tolerance: [0, [Validators.required, Validators.min(0)]],
      month: ['',[Validators.required]],
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    
    if (changes['requestStatus'] && changes['requestStatus'].currentValue === RequestStatus.None) {
      this.fileUpload?.clear();   
      
      this.fileUploadForm.reset({
        name: '',  
        tolerance: 0,  
        month: '',  
      });
      
      this.files = [];
    }
  }
  
  
  onDragOver(event: DragEvent): void {
    event.preventDefault();
  }

  onFileSelect(event: any): void {
    const files: File[] = Array.from(event.files);
    files.forEach((file) => {
      if (this.allowedMimeTypes.includes(file.type)) {
        if (files.length > 1) {
          this.notificationService.showInfo('You can only select one file.');
          this.fileUpload?.clear();
          return;
        }
        if(this.files.length > 0){
          this.notificationService.showInfo('You can only select one file.');
        }else{
          this.files.push(file);
        }
      } else {
        console.warn('Invalid file type:', file.name);
      }
    });
    this.fileUpload?.clear();
  }

  formatFileSize(sizeInBytes: number): string {
    const sizeInKB = sizeInBytes / 1024;
    const sizeInMB = sizeInKB / 1024;
    return sizeInMB >= 1
      ? `${sizeInMB.toFixed(2)} MB`
      : `${sizeInKB.toFixed(2)} KB`;
  }

  onFileDrop(event: DragEvent): void {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.handleFiles(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  }

  handleFiles(files: FileList): void {
    Array.from(files).forEach((file) => {
      if (this.allowedMimeTypes.includes(file.type)) {
        if(this.files.length > 0){
          this.notificationService.showWarn('You can\'t select more than one file');
        }else{
          this.files.push(file);
        }
      } else {
        console.warn('Invalid file type:', file.name);
      }
    });
  }

  removeFile(index: number) {
    this.files.splice(index, 1);
  }


  async uploadFile() {
    try {
      this.fileUploadForm.markAllAsTouched();
      this.isSubmitted.set(true);
      if (!this.fileUploadForm.valid) return;

      const monthValue = this.fileUploadForm.get('month')?.value;
      const formattedDate = new Intl.DateTimeFormat("en-US", { month: "long", year: "numeric" }).format(new Date(monthValue));

      const data: FileUploadReq = {
        files: this.files,
        data: {
          tolerance: this.fileUploadForm.get('tolerance')?.value,
          month: formattedDate,
          name: this.fileUploadForm.get('name')?.value,
        }
      };

      this.selectedFiles.emit(data);
    } catch (e) {
      console.error('Error during upload:', e);
    }
  }



}
